import React, { useState, useEffect } from "react";
import FOSidebar from "../../components/MasterSideBar";
import TopBar from "../../components/TopbarNav";
import ReportCaseForm from "../../components/ReportCaseForm";
import MyCases from "../../components/MyCases";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { jwtDecode } from "jwt-decode";
import { MdClose } from "react-icons/md";

const FODisciplinary = () => {
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const [userId, setUserId] = useState(null);
    const [showForm, setShowForm] = useState(false);

    useEffect(() => {
        const token = localStorage.getItem("token");
        if (token) {
            try {
                const decoded = jwtDecode(token);
                setUserId(decoded.id || decoded.userId);
            } catch (err) {
                console.error("Error decoding token:", err);
                const storedUser = localStorage.getItem("user");
                if (storedUser) {
                    try {
                        const parsedUser = JSON.parse(storedUser);
                        setUserId(parsedUser.id || parsedUser.userId);
                    } catch (err) {
                        console.error("Error parsing user from localStorage:", err);
                    }
                }
            }
        }
    }, []);

    if (!userId) {
        return (
            <div className="flex items-center justify-center min-h-screen bg-gray-100">
                <div className="text-gray-500 text-lg">Loading user data...</div>
            </div>
        );
    }

    return (
        <div className="flex h-screen bg-gray-50 font-sans">
            <FOSidebar
                visible={sidebarOpen}
                onClose={() => setSidebarOpen(false)}
            />

            <div className="flex flex-col flex-1 overflow-hidden">
                <TopBar onSidebarToggle={() => setSidebarOpen(true)} />

                <main className="flex-1 overflow-auto p-6 pt-24 md:pt-20 md:ml-64">
                    <div className="flex flex-col md:flex-row items-start md:items-center justify-between mb-6 mt-6">
                        <h1 className="text-2xl font-bold text-orange-600">My Disciplinary Cases</h1>
                        <button
                            onClick={() => setShowForm(true)}
                            className="mt-4 md:mt-0 bg-orange-500 text-white px-5 py-2.5 rounded-lg shadow-md hover:bg-orange-600 transition-colors"
                        >
                            Report a New Case
                        </button>
                    </div>

                    {showForm && (
                        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4">
                            <div className="bg-white w-full max-w-lg rounded-lg shadow-2xl p-6 relative overflow-y-auto max-h-[90vh]">
                                <div className="flex justify-between items-center border-b pb-3 mb-4">
                                    <h2 className="text-xl font-bold text-orange-600">
                                        Report a New Case
                                    </h2>
                                    <button
                                        onClick={() => setShowForm(false)}
                                        className="text-gray-500 hover:text-gray-700 transition-colors p-1"
                                    >
                                        <MdClose size={24} />
                                    </button>
                                </div>
                                <ReportCaseForm
                                    reporterId={userId}
                                    onClose={() => {
                                        setShowForm(false);
                                        toast.success("Case reported successfully! It is now awaiting review.", {
                                            position: "top-center",
                                            autoClose: 4000,
                                            hideProgressBar: false,
                                            closeOnClick: true,
                                            pauseOnHover: true,
                                            draggable: true,
                                            progress: undefined,
                                            style: {
                                                background: "#FFEDD5",
                                                color: "#92400E",
                                                fontWeight: "500",
                                                fontSize: "16px",
                                                textAlign: "center",
                                                borderRadius: "8px",
                                            },
                                        });
                                    }}
                                />
                            </div>
                        </div>
                    )}

                    <MyCases userId={userId} />

                    <ToastContainer />
                </main>
            </div>
        </div>
    );
};

export default FODisciplinary;
